import type { ComponentChildren } from 'preact';

import { cx } from '@amumin/ui-core';

import styles from './SectionHeader.module.css';

export interface SectionHeaderProps {
  title: ComponentChildren;
  /** Kopniveau: h2 (standaard) of h3 binnen een sectie. De maat is gelijk; alleen de structuur. */
  level?: 2 | 3 | undefined;
  /** Rechts: een telling ("4") of één tekstknop/link ("Alles", "Toevoegen"). */
  count?: number | string | undefined;
  action?: ComponentChildren | undefined;
  /** `group` = kleine groepskop (meta, 13 px) boven een lijst; standaard een sectiekop (17 px). */
  tone?: 'section' | 'group' | undefined;
  id?: string | undefined;
  name?: string | undefined;
}

/**
 * Sectiekop (docs/ux/ontwerpsysteem.md): er zijn er twee maten, sectie (lead 17/650) en groep
 * (meta 13/600). Een kop is nooit groter dan de paginatitel.
 */
export function SectionHeader({
  title,
  level = 2,
  count,
  action,
  tone = 'section',
  id,
  name,
}: SectionHeaderProps) {
  const H = level === 3 ? 'h3' : 'h2';
  return (
    <div class={cx(styles.head, tone === 'group' && styles.group)} data-name={name}>
      <H class={styles.title} id={id}>
        {title}
      </H>
      {count !== undefined ? <span class={cx(styles.count, 'tabular')}>{count}</span> : null}
      {action ? <div class={styles.action}>{action}</div> : null}
    </div>
  );
}
